var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"retail-layout"},[_c('Header'),(_vm.$store.getters.appAvailable && !_vm.$store.getters.fetchEventsError)?_c(_vm.selectLayout,{tag:"component"}):_vm._e(),_c('Notification',{attrs:{"title":"reconnecting","valid":_vm.$store.getters.connectionError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }